/* eslint-disable no-shadow */
import React, { useEffect, useState, useContext } from "react";
import { Droppable, Draggable } from "react-beautiful-dnd";
import Accordion from "react-bootstrap/Accordion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import AccordionContext from "react-bootstrap/AccordionContext";
import Card from "react-bootstrap/Card";
import { ChevronDown, ChevronUp } from "react-feather";
import "./courseStyles.scss";
import Component from "./component";

function CustomToggle({ children, eventKey, callback, setIsOpen, setComponentForm }) {
  const { activeEventKey } = useContext(AccordionContext);

  const decoratedOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey));

  // const isCurrentEventKey = activeEventKey === eventKey;
  // setIsOpen(isCurrentEventKey);

  useEffect(() => {
    // Actualiza isOpen solo cuando activeEventKey cambie
    setIsOpen(activeEventKey === eventKey);
  }, [activeEventKey, eventKey]);

  return (
    <button
      type="button"
      id="unit"
      onClick={() => {
        decoratedOnClick();
        setComponentForm(null);
      }}
    >
      {children}
    </button>
  );
}

export default function CourseUnit({ setUnitInfo, setComponenInfo, order, unit, setComponentForm }) {
  const [isOpen, setIsOpen] = useState(order === 1);
  const [componentList, setComponentList] = useState([]);
  componentList.sort((a, b) => a.sort_order - b.sort_order);
  const key = order === 1 ? "0" : unit.id.toString();

  useEffect(() => {
    if (unit && unit.labComponent) {
      setComponentList(unit.labComponent);
    }
  }, [unit]);

  useEffect(() => {
    if (isOpen) {
      setUnitInfo({ title: unit.title, order, id: unit.id, components: unit.labComponent });
    }
  }, [isOpen, unit]);

  const handleComponentClick = (component) => {
    setComponenInfo(component);
  };

  return (
    <>
      <div id="acordion">
        <Card.Header id="acordion-header">
          <div className="handler">
            <FontAwesomeIcon icon="fa-solid fa-grip-vertical" />
          </div>
          <CustomToggle eventKey={key} setIsOpen={setIsOpen} isOpen={isOpen} setUnitInfo={setUnitInfo} setComponentForm={setComponentForm}>
            <div className="d-flex justify-content-between align-items-center px-2 py-1 w-100">
              <div
                style={{
                  overflow: "hidden" /* Oculta el desbordamiento */,
                  textOverflow: "ellipsis" /* Agrega puntos suspensivos si el texto es demasiado largo */,
                  whiteSpace: "nowrap" /* Evita el ajuste de línea */,
                  width: "90%",
                  textAlign: "left",
                  // margin: "2px",
                  // fontFamily: "Nunito",
                }}
              >
                {unit.title || "Unidad 1"}
              </div>
              {isOpen ? <ChevronUp size="22" /> : <ChevronDown size="22" />}
            </div>
          </CustomToggle>
        </Card.Header>
        <Accordion.Collapse eventKey={key}>
          <Card.Body className="pr-0 py-1">
            <Droppable droppableId={`${unit.id}-droppable`} type="blockList">
              {(provided) => (
                <div {...provided.droppableProps} ref={provided.innerRef}>
                  {componentList.length > 0 ? (
                    componentList.map((item, index) => (
                      <Draggable key={item.id} draggableId={`${item.title}-${unit.id}-Inner${item.id}`} index={index} type="block">
                        {(provided) => (
                          <div id="component-container" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                            <Component onClick={handleComponentClick} title={item.title} component={item} />
                          </div>
                        )}
                      </Draggable>
                    ))
                  ) : (
                    <div className="d-flex justify-content-center align-items-center">
                      <p>Aún no hay componentes en esta unidad</p>
                    </div>
                  )}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </Card.Body>
        </Accordion.Collapse>
      </div>
    </>
  );
}
